import { useEffect, useState, useRef } from "react";
import "../../assets/css/viewGame.css";
import "../../assets/css/layout.css";
import { Socket } from "socket.io-client";

import { useHistory, useLocation, NavLink } from "react-router-dom";
import css from "../../assets/css/Pan.module.css";
import Swal from "sweetalert2";
import "../../assets/css/Loader.css";
import io from "../Components/socket";
import Compressor from "compressorjs";
import Modal from "react-bootstrap/Modal";
import AppLoader from "../Components/AppLoader";

import "bootstrap/dist/css/bootstrap.min.css";
import { apiRequest } from "../../apiService/allApi";

export default function ViewGame(props) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show_won, setShow_won] = useState(false);
  const handleClose_won = () => setShow_won(false);

  const handleShow_won = () => setShow_won(true);

  const [show_lost, setShow_lost] = useState(false);
  const handleClose_lost = () => setShow_lost(false);

  const handleShow_lost = () => setShow_lost(true);
  const [isChecked, setIsChecked] = useState(false);

  const history = useHistory();

  const location = useLocation();
  const path = location.pathname.split("/")[2];

  const [Game, setGame] = useState("0");
  const [status, setStatus] = useState(null);

  const [fecthStatus, setFecthStatus] = useState();
  const [scrnshot, setScrnshot] = useState(null);
  const [scrnshot1, setScrnshot1] = useState("");
  const [initialRoom, setInitialRoom] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [isLoading1, setIsloading1] = useState(false);

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [reason, setReason] = useState(null);

  const [roomcode, setRoomcode] = useState();
  let submitReq = useRef(false);

  const [submitProcess, setProcess] = useState(true);
  const handleChangeCheckbox = () => {
    setIsChecked(!isChecked);
  };

  const [user, setUser] = useState();

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    Allgames(userId);
    setUser(userId);
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      history.push("/login");
    }
  }, []);
  useEffect(() => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    Allgames(userId);
    setUser(userId);
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      history.push("/login");
    }
  }, [props.userData]);

  useEffect(() => {
    io.on("updateroomcode", (data) => {
      let userId = localStorage.getItem("userId");

      if (data?.Accepetd_By?._id == userId) {
        setInitialRoom(data);
        setGame(data);
      }
    });
  }, [initialRoom.Room_code == 0]);

  const getRoomCode = async () => {
    setIsloading1(true);
    try {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const res = await apiRequest(
        `challange/roomcode/${path}`,
        "PATCH",
        { Room_code: roomcode },
        headers,
      );

      if (res.data?.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      } else {
        setGame(res.data);
      }
    } catch (error) {
      const message =
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        "Roomcode API request failed";
      Swal.fire({
        title: message,
        icon: "warning",
        confirmButtonText: "OK",
      });
    } finally {
      setIsloading1(false);
    }
  };

  const [ALL, setALL] = useState();

  const Allgames = async (userId) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(`challange/${path}`, "GET", null, headers);
    if (res.data?.status == false) {
      Swal.fire({
        title: res.data.msg,
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    if (res.data?.Status == "new" || res.data.Status == "requested") {
      setTimeout(async () => {
        const res = await apiRequest(`challange/${path}`, "GET", null, headers);
        if (res.data.Status == "new" || res.data.Status == "requested") {
          history.push(props?.location?.state?.prevPath);
        } else {
          setProcess(false);
        }
      }, 10000);
    } else {
      setProcess(false);
    }
    setALL(res.data);
    setGame(res.data);

    if (userId == res.data.Accepetd_By._id) {
      setFecthStatus(res.data.Acceptor_status);
    }

    if (userId == res.data.Created_by._id) {
      setFecthStatus(res.data.Creator_Status);
    }
  };
  const [showDiv, setShowDiv] = useState(true);
  const [secondsRemaining, setSecondsRemaining] = useState(null);

  const createdAtTimestamp = new Date(Game.createdAt).getTime();

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const currentTime = new Date().getTime();
      const differenceInSeconds = Math.floor(
        (currentTime - createdAtTimestamp) / 1000,
      );
      if (differenceInSeconds >= 500) {
        setShowDiv(false);
      } else {
        setSecondsRemaining(500 - differenceInSeconds);
      }
    };

    calculateTimeRemaining();

    const timer = setInterval(() => {
      calculateTimeRemaining();
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [createdAtTimestamp]);

  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
    setStatus(null);
  };

  const Result = async (e) => {
    e.preventDefault();

    if (submitReq.current == false) {
      submitReq.current = true;
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      if (status) {
        setProcess(true);
        const formData = new FormData();
        if (scrnshot != null) {
          formData.append("file", scrnshot);
        }
        formData.append("status", status);
        if (status == "cancelled") {
          formData.append("reason", reason);
        }

        const res = await apiRequest(
          `challange/result/${path}`,
          "POST",
          formData,
          headers,
        );
        if (res.data?.status == false) {
          submitReq.current = false;
          setProcess(false);
          Swal.fire({
            position: "center",
            icon: "error",
            type: "error",
            title: res.data.msg,
            showConfirmButton: true,
          });
        } else {
          io.emit("resultAPIdata", path);
          submitReq.current = false;
          setProcess(false);
          history.push(props?.location?.state?.prevPath);
        }
      } else {
        submitReq.current = false;
        alert("please fill all field or Re-Select result status");
      }
    }
  };

  const copyCode = (e) => {
    navigator.clipboard.writeText(Game.Room_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Room Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const handleSetRoomCode = () => {
    const inputValue = roomcode;
    if (Game.Game_type !== "LudoSnake") {
      if (
        /^[0-9]+$/.test(inputValue) &&
        inputValue.length === 8 &&
        inputValue[0] === "0"
      ) {
        getRoomCode();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Please enter a valid 8-digit code that starts with 0.",
          showConfirmButton: true,
        });
      }
    } else {
      getRoomCode();
    }
  };

  function winnAmount(gameAmount) {
    let profit = null;
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  const styles = {
    backgroundColor: "#fff",
    color: "black",
  };

  useEffect(() => {
    io.on("notify", (data) => {
      if (data.GameID == path) {
        Swal.fire({
          title: data.msg,
          icon: "success",
          confirmButtonText: "OK",
        });
        history.push("/Homepage/ludoClassicManual");
      }
    });
  }, [Socket]);

  return (
    <>
      {Game && (
        <div
          className="leftContainer page_layout"
          style={{
            background:
              "linear-gradient(135deg, #dbeafe 0%, #eff6ff 40%, transparent 100%)",
          }}
        >
          <div className="Orher_page_main_section">
            <div className="alrt_msg_div">
              <h5 className="">
                {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                  ? ""
                  : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.ludoClassicAutobattleMsg}
              </h5>
            </div>

            <div className="main-area">
              <div className="viewgame_topbtn">
                <div>
                  <span
                    className={`${css.gamesSectionHeadline} text-uppercase font-weight-bold rule_view text-dark`}
                  >
                    <NavLink to="/Homepage" className="text-dark ">
                      <div className="back-3d-icon">
                        <img alt="Back" src="/images/back-icon.png" />
                        Back
                      </div>
                    </NavLink>
                  </span>
                </div>

                <div className=""></div>
              </div>
              {!Boolean(submitProcess) && (
                <div className="battleCard-bg mb-sm-5">
                  <div className="battleCard mb-sm-5">
                    <div className="view-box-card">
                      <div className="players cxy pt-2 ">
                        <div className=" cxy">
                          {Game?.Created_by?.avatar ? (
                            <img
                              src={baseUrl + `/${Game.Created_by?.avatar}`}
                              width="50px"
                              height="50px"
                              alt="a"
                              style={{
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <img
                              src="/images/avatars/Avatar2.png"
                              width="40px"
                              height="40px"
                              alt="user"
                              style={{
                                borderRadius: "50%",
                                border: "2px solid #fff",
                              }}
                            />
                          )}
                          <h5
                            className="ml-2 mb-0 font-weight-bold"
                            style={{ color: "#0f172a" }}
                          >
                            {Game.Created_by?.Name.length > 5
                              ? `${Game.Created_by?.Name.slice(0, 5)}...`
                              : Game.Created_by?.Name}
                          </h5>
                        </div>
                        <img
                          className="mx-3 img-bet view-bet"
                          src={
                            process.env.PUBLIC_URL +
                            "/images/Homepage/versus.png"
                          }
                          width=""
                          alt=""
                        />
                        <div className=" cxy ">
                          {Game?.Accepetd_By?.avatar ? (
                            <img
                              src={baseUrl + `/${Game.Accepetd_By.avatar}`}
                              width="40px"
                              height="40px"
                              alt=""
                              style={{
                                borderRadius: "50%",
                                border: "2px solid #e2e8f0",
                              }}
                            />
                          ) : (
                            <img
                              src="/images/avatars/Avatar2.png"
                              width="40px"
                              height="40px"
                              alt=""
                              style={{
                                borderRadius: "50%",
                                border: "2px solid #e2e8f0",
                              }}
                            />
                          )}
                          <h5
                            className="ml-2 mb-0 font-weight-bold"
                            style={{ color: "#0f172a" }}
                          >
                            {" "}
                            {Game.Accepetd_By?.Name.length > 5
                              ? `${Game.Accepetd_By?.Name.slice(0, 5)}...`
                              : Game.Accepetd_By?.Name}
                          </h5>
                        </div>
                      </div>
                      <div
                        className="d-flex justify-content-between px-3 mt-2 pt-2"
                        style={{ borderTop: "1px solid #e2e8f0" }}
                      >
                        <div className="mt-0 text-left">
                          <p
                            className="d-block mb-0 fw-bold"
                            style={{
                              color: "#64748b",
                              fontSize: "12px",
                              textTransform: "uppercase",
                            }}
                          >
                            Entry Fee
                          </p>
                          <div className="amount d-flex align-items-center mt-0">
                            <img
                              className="mr-1"
                              src="/images/rupee.png"
                              style={{ width: "16px", height: "16px" }}
                              alt=""
                            />

                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: 800,
                                color: "#0f172a",
                              }}
                            >
                              {Game.Game_Ammount}
                            </span>
                          </div>
                        </div>
                        <div className="text-right">
                          <span
                            className="d-block fw-bold mb-0 text-right"
                            style={{
                              color: "#64748b",
                              fontSize: "12px",
                              textTransform: "uppercase",
                            }}
                          >
                            Winning Prize{" "}
                          </span>
                          <div className="amount d-flex align-items-center mt-0 justify-content-end">
                            <img
                              className="mr-1"
                              src="/images/rupee.png"
                              style={{ width: "16px", height: "16px" }}
                              alt=""
                            />

                            <span
                              style={{
                                fontSize: "18px",
                                fontWeight: 800,
                                color: "#10b981",
                              }}
                            >
                              {Game.Game_Ammount +
                                winnAmount(Game?.Game_Ammount)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="battle_card_main room-code"
                      style={{ borderRadius: "10px;" }}
                    >
                      {(Game.Room_code == null && (
                        <div className=" cxy flex-column ">
                          <h6 className="headings">
                            {" "}
                            Waiting for Room Code...{" "}
                          </h6>
                          <AppLoader
                            size="md"
                            color="primary"
                            style={{ margin: "14px 0" }}
                          />
                        </div>
                      )) ||
                        (Game.Room_code != "0" && (
                          <div className="cyber-container">
                            <div className="cyber-room-card">
                              <div className="corner-tl"></div>
                              <div className="corner-br"></div>

                              <div className="cyber-content">
                                <div className="cyber-label-group">
                                  <p className="glitch-text">
                                    🎮 Match Room Ready
                                  </p>
                                  <h4 className="cyber-title">Room Code</h4>
                                </div>

                                <div className="code-vault">
                                  <span className="vault-id">
                                    {Game.Room_code}
                                  </span>
                                </div>

                                <button
                                  className="cyber-btn"
                                  onClick={(e) => copyCode(e)}
                                >
                                  <span className="btn-glitch-effect">
                                    Copy Room Code
                                  </span>
                                  <i className="fa fa-copy ml-2"></i>
                                </button>
                                <div
                                  className="mt-2 text-muted"
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Open Ludo King ➔ Play With Friends ➔ Join
                                </div>
                              </div>
                            </div>
                          </div>
                        )) ||
                        (Game.Room_code == "0" &&
                          ((Game.Created_by._id == user &&
                            Game.Room_code == "0" && (
                              <>
                                <>
                                  {showDiv ? (
                                    <div className="cxy flex-column ">
                                      <h6 className="pt-4 text-dark">
                                        <b>
                                          Upload the room code from Ludo King
                                        </b>
                                      </h6>
                                      <div
                                        className="pt-1 text-primary"
                                        style={{
                                          fontWeight: "bold",
                                          fontSize: "20px",
                                        }}
                                      >
                                        {showDiv ? (
                                          <div>
                                            <p>
                                              <span
                                                style={{ fontSize: "25px" }}
                                              >
                                                {" "}
                                                {secondsRemaining}{" "}
                                              </span>
                                              seconds
                                            </p>
                                          </div>
                                        ) : (
                                          <div>
                                            <p style={{ color: "red" }}>
                                              Your Time is Complete please Reset
                                              bettel !
                                            </p>
                                          </div>
                                        )}
                                      </div>

                                      <label
                                        className="d-block mr-auto text-dark"
                                        htmlFor=""
                                      >
                                        <b>Enter Room Code</b>{" "}
                                      </label>
                                      <div class="user_reder_code_box room-input mt-2">
                                        {" "}
                                        <input
                                          class="commaon_input_box"
                                          type="number"
                                          placeholder="Room Code"
                                          value={roomcode}
                                          onChange={(e) =>
                                            setRoomcode(e.target.value)
                                          }
                                        />
                                        <div class="set Refer_code check_btn">
                                          {" "}
                                          {isLoading1 ? (
                                            <button
                                              className="glow-btn ml-3 "
                                              disabled
                                              style={{ height: "" }}
                                            >
                                              <AppLoader
                                                size="sm"
                                                color="white"
                                                className="mr-2"
                                              />
                                              Loading...
                                            </button>
                                          ) : (
                                            <button
                                              class="glow-btn ml-2"
                                              onClick={handleSetRoomCode}
                                            >
                                              Set
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </>

                                <div className="rules mt-3">
                                  <div
                                    className="py-2 px-3 text-center"
                                    style={{
                                      backgroundColor: "#eff6ff",
                                      color: "#1d4ed8",
                                      borderRadius: "10px",
                                      border: "1px solid #bfdbfe",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "6px",
                                    }}
                                  >
                                    <span>ℹ️</span>
                                    <span>
                                      Please copy the room code from Ludo King
                                      and enter it above
                                    </span>
                                  </div>
                                </div>
                              </>
                            )) ||
                            (Game.Accepetd_By._id == user &&
                              Game?.Room_code == "0" && (
                                <>
                                  <>
                                    {showDiv ? (
                                      <>
                                        <div
                                          style={{
                                            textAlign: "center",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          <h6 className=" text-dark">
                                            {" "}
                                            Waiting for Room Code{" "}
                                          </h6>
                                          <h6 className="  text-dark">
                                            Waiting for room code. [
                                            {secondsRemaining}]
                                          </h6>

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              padding: "16px 0",
                                            }}
                                          >
                                            <AppLoader
                                              size="md"
                                              color="primary"
                                            />
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <div>
                                        <p
                                          style={{
                                            color: "#000",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Waiting For Room Code
                                        </p>
                                      </div>
                                    )}
                                  </>

                                  <div className="rules mt-3">
                                    <div
                                      className="py-2 px-3 text-center"
                                      style={{
                                        backgroundColor: "#fffbeb",
                                        color: "#b45309",
                                        borderRadius: "10px",
                                        border: "1px solid #fde68a",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <span>⏳</span>
                                      <span>
                                        Please wait. The other player is sharing
                                        the room code from Ludo King.
                                      </span>
                                    </div>
                                  </div>
                                </>
                              ))))}
                    </div>

                    <div className="match-status-box">
                      <div
                        className="match-status-border default-border-bottom  text-center profile_headings"
                        style={{
                          background: "transparent",
                          color: "#000",
                          fontSize: "25px",
                          marginBottom: "10px",
                        }}
                      >
                        Match Status
                      </div>
                      <form
                        className="result-area"
                        onSubmit={(e) => {
                          Result(e);
                        }}
                        encType="multipart/form-data"
                      >
                        {fecthStatus !== null && fecthStatus !== undefined && (
                          <p style={{ color: "red" }}>
                            You have already updated your battle result for{" "}
                            <h6 className="d-inline-block text-uppercase">
                              <b>{fecthStatus}</b>
                            </h6>
                          </p>
                        )}
                        {fecthStatus === null && (
                          <>
                            <div
                              className=" radios result_buttons_group"
                              role="radiogroup"
                              aria-label="Result"
                            >
                              <label className="MuiFormControlLabel-root hidden Mui-disabled">
                                <span
                                  className="MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root MuiRadio-colorSecondary jss2 Mui-checked jss3 Mui-disabled MuiIconButton-colorSecondary Mui-disabled Mui-disabled"
                                  tabIndex={-1}
                                  aria-disabled="true"
                                >
                                  <span className="MuiIconButton-label">
                                    <input
                                      className="jss4 mr-2"
                                      name="battleResult"
                                      type="radio"
                                      defaultValue="select"
                                      defaultChecked
                                      style={{ transform: "scale(1.5)" }}
                                    />
                                  </span>
                                </span>
                                <span
                                  className="MuiTypography-root MuiFormControlLabel-label Mui-disabled MuiTypography-body1"
                                  style={{ marginTop: "3px" }}
                                >
                                  (Disabled option)
                                </span>
                              </label>
                              {Game.Room_code != "0" ? (
                                <>
                                  <label className="MuiFormControlLabel-root results_btn results_btn_win">
                                    <span
                                      className="MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root jss8"
                                      aria-disabled="false"
                                    >
                                      <span className="MuiIconButton-label">
                                        <input
                                          className="jss4 mr-2"
                                          name="battleResult"
                                          type="radio"
                                          defaultValue="winn"
                                          onClick={() => {
                                            setStatus("winn");
                                            handleShow_won();
                                          }}
                                          style={{ transform: "scale(1.5)" }}
                                        />
                                      </span>
                                      <span className="MuiTouchRipple-root" />
                                    </span>
                                    <span
                                      className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                                      style={{ marginTop: "3px" }}
                                    >
                                      I Won
                                    </span>
                                  </label>
                                  <label className="MuiFormControlLabel-root results_btn results_btn_lose">
                                    <span
                                      className="MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary"
                                      aria-disabled="false"
                                      root="[object Object]"
                                    >
                                      <span className="MuiIconButton-label">
                                        <input
                                          className="jss4 mr-2"
                                          name="battleResult"
                                          type="radio"
                                          defaultValue="lose"
                                          onClick={() => {
                                            setStatus("lose");

                                            handleShow_lost();
                                          }}
                                          style={{ transform: "scale(1.5)" }}
                                        />
                                      </span>
                                      <span className="MuiTouchRipple-root" />
                                    </span>
                                    <span
                                      className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                                      style={{ marginTop: "3px" }}
                                    >
                                      I Lost
                                    </span>
                                  </label>
                                </>
                              ) : (
                                ""
                              )}
                              <label className="MuiFormControlLabel-root results_btn results_btn_cancel">
                                <span
                                  className="MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root"
                                  aria-disabled="false"
                                >
                                  <span className="MuiIconButton-label">
                                    <input
                                      className="jss4 mr-2"
                                      name="battleResult"
                                      type="radio"
                                      defaultValue="cancelled"
                                      onClick={() => {
                                        setStatus("cancelled");
                                        handleShow();
                                      }}
                                      style={{ transform: "scale(1.5)" }}
                                    />
                                  </span>
                                  <span className="MuiTouchRipple-root" />
                                </span>
                                <span
                                  className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                                  style={{ marginTop: "3px" }}
                                >
                                  Cancel
                                </span>
                              </label>
                            </div>
                          </>
                        )}

                        <section className="game_result_submit_model">
                          <Modal
                            show={show}
                            onHide={handleClose}
                            className="cancel_popup_reason_popup cls"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                          >
                            <Modal.Header closeButton>
                              <h3 className="modal-title font-weight-bold">
                                Cancel Battle
                              </h3>
                            </Modal.Header>
                            <Modal.Body>
                              <div>
                                <h5
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    color: "#475569",
                                    textAlign: "center",
                                    marginBottom: "14px",
                                  }}
                                >
                                  Select reason for cancelling:
                                </h5>

                                <div className="cancel_reasons_grid">
                                  {[
                                    "No Room code",
                                    "Not joined",
                                    "Not Playing",
                                    "Dont Want to Play",
                                    "Opponent Abusing",
                                    "Game not Started",
                                    "Others",
                                  ].map((reasonItem) => {
                                    const isSelected =
                                      selectedReason === reasonItem;
                                    return (
                                      <button
                                        key={reasonItem}
                                        type="button"
                                        className={`cancel_reason_btn ${
                                          isSelected ? "nav_active" : ""
                                        }`}
                                        onClick={() => {
                                          setSelectedReason(reasonItem);
                                          setStatus("cancelled");
                                          if (reasonItem === "Others") {
                                            setShowInput(true);
                                            setReason("");
                                          } else {
                                            setShowInput(false);
                                            setReason(reasonItem);
                                          }
                                        }}
                                      >
                                        {reasonItem}
                                      </button>
                                    );
                                  })}
                                </div>

                                {showInput && (
                                  <div className="form-group mt-3">
                                    <textarea
                                      className="form-control"
                                      placeholder="Write your reason for cancellation..."
                                      rows="3"
                                      value={reason}
                                      onChange={(e) => {
                                        setReason(e.target.value);
                                        setSelectedReason("Others");
                                      }}
                                      style={{
                                        borderRadius: "14px",
                                        border: "1.5px solid #cbd5e1",
                                        padding: "10px 14px",
                                        fontSize: "13px",
                                        background: "#f8fafc",
                                      }}
                                    ></textarea>
                                  </div>
                                )}

                                {fecthStatus == null &&
                                  fecthStatus == undefined && (
                                    <input
                                      type="submit"
                                      value="Confirm Cancellation"
                                      className="submit-glass-btn results_btn_cancel mt-3"
                                      id="post"
                                      onClick={(e) => {
                                        if (selectedReason) {
                                          if (
                                            selectedReason === "Others" &&
                                            (!reason || !reason.trim())
                                          ) {
                                            Swal.fire({
                                              position: "center",
                                              icon: "warning",
                                              title: "Please write your reason",
                                              showConfirmButton: false,
                                              timer: 1500,
                                            });
                                            return;
                                          }
                                          Result(e);
                                        } else {
                                          Swal.fire({
                                            position: "center",
                                            icon: "error",
                                            type: "error",
                                            title: "Please Select Reason First",
                                            showConfirmButton: false,
                                            timer: 1200,
                                          });
                                        }
                                      }}
                                    />
                                  )}
                              </div>
                            </Modal.Body>
                          </Modal>
                        </section>

                        <section className="win_modal ">
                          <Modal
                            show={show_won}
                            onHide={handleClose_won}
                            className="cancel_popup_reason_popup upload_result"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                          >
                            <Modal.Header closeButton>
                              <h3 className="modal-title font-weight-bold">
                                Upload Result
                              </h3>
                            </Modal.Header>

                            <Modal.Body className="pt-2">
                              <div className="upload-wrapper-stack">
                                

                                {status !== null &&
                                  status !== "cancelled" &&
                                  status !== "lose" && (
                                    <div className="upload-interactive-card">
                                      <input
                                        type="file"
                                        onChange={handleChange}
                                        accept="image/*"
                                        required
                                        className="input-overlay-hidden"
                                      />

                                      {!scrnshot ? (
                                        <div className="drag-content">
                                          <div className="add-circle">
                                            +
                                          </div>
                                          <p>Add Image</p>
                                        </div>
                                      ) : (
                                        <div className="success-file-badge">
                                          <div className="badge-left">
                                            <div className="file-preview-mini">
                                              <img
                                                src="/images/file-icon.png"
                                                alt="icon"
                                              />
                                            </div>
                                            <div className="file-meta-data">
                                              <p className="m-0 truncate-text">
                                                {scrnshot.name}
                                              </p>
                                              <small>
                                                {(
                                                  scrnshot.size /
                                                  1024 /
                                                  1024
                                                ).toFixed(2)}{" "}
                                                MB
                                              </small>
                                            </div>
                                          </div>
                                          <button
                                            className="clear-btn-minimal"
                                            type="button"
                                            onClick={() => {
                                              clearImage();
                                            }}
                                          >
                                            x
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  )}

                                {scrnshot1 && (
                                  <div className="uploaded-image-preview-container">
                                    <img
                                      src={scrnshot1}
                                      alt="Uploaded Proof"
                                      className="uploaded-image-preview"
                                    />
                                  </div>
                                )}

                                <div className="button-stack-area">
                                  {fecthStatus == null &&
                                    fecthStatus == undefined && (
                                      <button
                                        type="submit"
                                        className={`submit-glass-btn ${!scrnshot ? "btn-locked" : "btn-active"}`}
                                        id="post"
                                        onClick={(e) => Result(e)}
                                        disabled={!scrnshot}
                                      >
                                        {scrnshot
                                          ? "Send Submission"
                                          : "Select File First"}
                                      </button>
                                    )}
                                </div>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </section>

                        <section className="">
                          <Modal
                            show={show_lost}
                            onHide={handleClose_lost}
                            className="modern-lost-modal"
                            centered
                          >
                            <Modal.Header closeButton>
                              <h3 className="modal-title font-weight-bold">
                                Confirm Defeat
                              </h3>
                            </Modal.Header>

                            <Modal.Body className="text-center py-4">
                              <p className="hindi-instruction">
                                कृपया ध्यान दें: परिणाम सबमिट करने के बाद इसे
                                बदला नहीं जा सकता।
                              </p>

                              <div className="confirm-box-wrapper">
                                <input
                                  type="checkbox"
                                  id="loast"
                                  name="loast"
                                  value="Yes, lost"
                                  checked={isChecked}
                                  onChange={handleChangeCheckbox}
                                />
                                <label htmlFor="loast">Yes, I Confirm</label>
                              </div>

                              <div className="action-footer-btns">
                                {fecthStatus == null &&
                                  fecthStatus == undefined && (
                                    <input
                                      disabled={!isChecked}
                                      type="submit"
                                      value="Yes, I Lost"
                                      className="action-btn-yes"
                                      id="post"
                                      onClick={(e) => {
                                        Result(e);
                                      }}
                                    />
                                  )}

                                <button
                                  onClick={handleClose_lost}
                                  className="action-btn-no"
                                >
                                  No
                                </button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </section>
                      </form>
                    </div>

                    <div
                      className="rules"
                      style={{
                        ...styles,
                        display: "grid",
                        justifyContent: "center",
                      }}
                    >
                      <h5 style={{ display: "flex", justifyContent: "center" }}>
                        Play ludo game in Ludo King App
                      </h5>
                      <div className="m-2 d-flex text-center   ">
                        <a href="https://ludokingnew.page.link/FPqXbMi3W7tAvj5t9">
                          <img
                            alt="Ludo King"
                            className=" w-50 border p-1 rounded"
                            src="/images/ludoking.png"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {Boolean(submitProcess) && (
              <AppLoader fullScreen text="Submitting..." />
            )}
          </div>
        </div>
      )}

      <div class="divider-y"></div>
    </>
  );
}
